import { mutatorAction } from 'satcheljs';
import store from '../store/store';

export const setShowPreviewLinesOptionMutator: (previewLines: number | null) => void =
    mutatorAction('setShowPreviewLinesOptionInListView', (previewLines: number | null): void => {
        store().showPreviewLinesInListView = previewLines;
    });

export const setTempPreviewLinesOptionMutator: (previewLines: number | null) => void =
    mutatorAction('setTempPreviewLinesOptionInListView', (previewLines: number | null): void => {
        store().tempPreviewLinesInListView = previewLines;
    });
